import { FormattedNumberInput } from '../FormattedNumberInput/FormattedNumberInput';
import type { FormattedNumberInputProps } from '../FormattedNumberInput/FormattedNumberInput';

export interface MoneyInputProps extends Omit<FormattedNumberInputProps, 'prefix' | 'decimalScale' | 'decimalsLimit'> {
    decimals?: number;
}

export const MoneyInput = ({
    decimals = 2,
    leadingVisual = '$',
    step = 1,
    maxLength = 10,
    ...rest
}: MoneyInputProps) => {
    return (
        <FormattedNumberInput
            {...rest}
            leadingVisual={leadingVisual}
            prefix={undefined}
            step={step}
            maxLength={maxLength}
            decimalScale={decimals}
            decimalsLimit={decimals}
            groupSeparator=","
            decimalSeparator="."
        />
    );
};
